export enum StatusCapaciteEnum {
  Vide = 'VIDE',
  Debute = 'DEBUTE',
  RealisteMaximale = 'REALISTE_MAXIMALE',
  RealisteEgaleMaximale = 'REALISTE_EGALE_MAXIMALE',
  Basse = 'BASSE',
  Haute = 'HAUTE'
}
